
/* @flow */

import { ETAPA_PENDENTE, ETAPAS_FINAIS } from '../pedidos/constants';
import { type Pedido, type Etapa } from '../pedidos/types';

const getEtapaPendente = (pedido: Pedido) => {
    if (!pedido.etapas) {
        return null;
    }

    const etapaPendente = pedido.etapas.find(etapa => etapa.etapasId === ETAPA_PENDENTE);

    if (!etapaPendente) {
        return null;
    }

    return etapaPendente;
};

const getEtapaExibida = (pedido: Pedido): Etapa => {
    if ([...ETAPAS_FINAIS, ETAPA_PENDENTE].includes(pedido.etapa.etapasId)) {
        return pedido.etapa;
    }

    const etapaPendente = getEtapaPendente(pedido);
    if (etapaPendente) {
        return etapaPendente;
    }

    return pedido.etapa;
};

export default getEtapaExibida;
